import React from 'react';
import styled from 'styled-components';

import { stylesFor } from '../styles/utilities';
import { Link } from './text';

export default ({ title, description, linkText, linkTarget, className }) => {
  const Root = styled.div`
    background-color: ${props => props.theme.color.white};
    background-size: cover;
    display: flex;
    flex-direction: column;
    padding: 40px;
    position: relative;

    ${stylesFor.xLargeUp`
      padding: 48px 80px;
    `};
  `;

  const Title = styled.span`
    display: block;
    font-size: 20px;
    font-weight: ${props => props.theme.font.weight.semibold};
    margin-bottom: 18px;

    ${stylesFor.xLargeUp`
      font-size: 28px;
      font-weight: ${props => props.theme.font.weight.regular};
    `};
  `;

  const Description = styled.span`
    color: ${props => props.theme.color.gray44};
    display: block;
    flex-grow: 1;
    font-size: 16px;

    ${stylesFor.mediumUp`
      font-size: 16px;
    `};
  `;

  return (
    <Root className={className}>
      <Title>{title}</Title>
      <Description>{description}</Description>
      <Link href={linkTarget}>
        {linkText}
        {!linkTarget && ' 😕'}
      </Link>
    </Root>
  );
};



// WEBPACK FOOTER //
// ./src/components/tile.js